module.exports = __webpack_public_path__ + "img/cached_black.ffece90b.svg";